import React, { Component } from 'react';

import CommonSubHeader from '../../SubHeader';
import './SubHeader.css';
import { inject, observer } from 'mobx-react';
import { Button, Input } from 'antd';
import { MagnifierIcon } from '../../../../common/icons';
import { ShoppingCartOutlined } from '@ant-design/icons';

@inject('translationsStore', 'connectionRequestsStore')
@observer
export default class SubHeader extends Component {
  render() {
    const { translationsStore, connectionRequestsStore } = this.props;
    const numberOfSubscriptionsToPay = connectionRequestsStore.connectionRequests.filter((connection, pos, self)=> !connection.portability_reference_contract_uuid || self.findIndex(el => el.vehicle.uuid === connection.vehicle.uuid) === pos).length;

    return (
      <CommonSubHeader className="SubHeaderConnectionRequests">
        <div className="SearchBar">
          <Input
            prefix={<MagnifierIcon />}
            placeholder={translationsStore.translate('search.placeholderSimple')}
            value={connectionRequestsStore.searchText}
            onChange={(e) => (connectionRequestsStore.searchText = e.target.value)}
            disabled={numberOfSubscriptionsToPay === 0}
          />
        </div>
        <div className={"OrderRecap"}>
          <div className={"RecapCount"}>
            {`${translationsStore.translate('connectionRequests.orderRecap.newSubscriptions')} ${numberOfSubscriptionsToPay}`}
            <hr />
          </div>
          <div className={'CartContainer'}>
            <div className={"CircleTotal"}>{numberOfSubscriptionsToPay}</div>
            <ShoppingCartOutlined className={'CartIcon'} />
          </div>
          <Button
            className={'ConfirmOrderButton'}
            onClick={this.props.onCheckout}
            disabled={numberOfSubscriptionsToPay === 0}
          >
            {translationsStore.translate('connectionRequests.orderRecap.confirm')}
            <br/>
            {translationsStore.translate('connectionRequests.orderRecap.order')}
          </Button>
        </div>
      </CommonSubHeader>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/SubHeader/SubHeader.js